module.exports = "/images/pipe.svg";